export default __webpack_public_path__ + "static/media/header-img.210dca96.png";